import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';
import { getOpxHostApi } from 'owa-opx';
import { isThemeModeSetByHostApp } from './isThemeModeSetByHostApp';
import { loadTheme } from './loadTheme';
import { opxThemeChangeHandler } from './opxThemeChangeHandler';
import { setCustomPalette } from '../mutators/setCustomPalette';
import { type ThemeId } from '../schema/ThemeId';
import { ThemeMode } from '../schema/ThemeMode';

/**
 * Initial load of theme from Opx host
 */
export const initializeThemeStoreForOpx = async (): Promise<void> => {
    const opxHostApi = getOpxHostApi();

    let isDarkTheme: boolean;
    let themeMode: ThemeMode;
    if (isThemeModeSetByHostApp()) {
        const miniHostAppDetail = getMiniHostAppDetail();
        isDarkTheme = miniHostAppDetail.isDarkTheme;
        themeMode = miniHostAppDetail.themeMode;
    } else {
        isDarkTheme = await opxHostApi.isDarkTheme();
        themeMode = isDarkTheme ? ThemeMode.Dark : ThemeMode.Light;
    }

    const opxPalette = await opxHostApi.getOpxPalette(isDarkTheme);
    setCustomPalette(opxPalette);

    getOpxHostApi().registerThemeChangedHandler(opxThemeChangeHandler);

    // Lite will always load default blue theme until it supports theming
    const themeId = 'Blue';

    loadTheme(themeId, themeMode);
};
